// Initial NDE Pricing data
const staticNDEPricing = {
  NDEPricing: [
    { no: 1, lineSize: 2.875, days: 0.0, dayRate: 0, filmEach: 8.0, filmEachValue: 0, total: 0.0 },
    { no: 2, lineSize: 3.5, days: 0.25, dayRate: 0, filmEach: 8.0, filmEachValue: 0, total: 0.0 },
    { no: 3, lineSize: 4.5, days: 0.32, dayRate: 0, filmEach: 8.0, filmEachValue: 0, total: 0.0 },
    { no: 4, lineSize: 6.625, days: 0.47, dayRate: 0, filmEach: 8.0, filmEachValue: 0, total: 292.0 },
    { no: 5, lineSize: 8.625, days: 0.62, dayRate: 0, filmEach: 8.0, filmEachValue: 0, total: 0.0 },
    { no: 6, lineSize: 10.75, days: 0.77, dayRate: 3353, filmEach: 10.0, filmEachValue: 0, total: 0.0 },
    { no: 7, lineSize: 12.75, days: 0.91, dayRate: 3353, filmEach: 10.0, filmEachValue: 0, total: 0.0 },
    { no: 8, lineSize: 16, days: 1.15, dayRate: 3353, filmEach: 12.0, filmEachValue: 0, total: 0.0 },
    { no: 9, lineSize: 18, days: 1.29, dayRate: 3353, filmEach: 13.0, filmEachValue: 0, total: 0.0 },
    { no: 10, lineSize: 20, days: 1.43, dayRate: 3353, filmEach: 14.0, filmEachValue: 0, total: 0.0 },
    { no: 11, lineSize: 24, days: 1.72, dayRate: 3353, filmEach: 17.0, filmEachValue: 0, total: 0.0 },
    { no: 12, lineSize: 26, days: 1.86, dayRate: 3353, filmEach: 18.0, filmEachValue: 0, total: 0.0 },
    { no: 13, lineSize: 30, days: 2.15, dayRate: 3353, filmEach: 18.5, filmEachValue: 0, total: 0.0 },
    { no: 14, lineSize: 36, days: 2.58, dayRate: 3353, filmEach: 21.0, filmEachValue: 0, total: 0.0 },
    { no: 15, lineSize: 42, days: 3.01, dayRate: 3353, filmEach: 25.0, filmEachValue: 0, total: 0.0 },
    { no: 16, lineSize: 48, days: 3.44, dayRate: 3353, filmEach: 26.0, filmEachValue: 0, total: 0.0 },
  ],
  totalLineSize: 0,
  totalDayRate: 0,
  totalFilm: 292.0,
};

// Generic day calculation function
const calculateDays = (lineSize, length3d) => {
  if (!lineSize || !length3d) return 0;

  const numerator = (length3d * 5280) / 40;
  const denominator = (200 / (Math.PI * lineSize)) * 8;

  return parseFloat((numerator / denominator).toFixed(2));
};

export const calculateNDEPricing = (quantities = [], costCategory = []) => {
  const length3d = parseFloat(quantities?.[6]?.quantity || 0);

  const updatedRows = staticNDEPricing.NDEPricing.map((row) => {
    const { lineSize, filmEach, dayRate } = row;

    const days = calculateDays(lineSize, length3d);

    const filmEachValue = length3d ? parseFloat((((length3d * 5280) / 40) * filmEach).toFixed(2)) : 0;

    const total = parseFloat((days * dayRate + filmEachValue).toFixed(2));

    return {
      ...row,
      days,
      filmEachValue,
      total,
    };
  });

  const totalLineSize = parseFloat(quantities?.[0]?.quantity || 0);
  const totalDayRate = parseFloat((totalLineSize * 3353).toFixed(2));

  // Match totalLineSize to lineSize and extract filmEachValue
  const matchedRow = updatedRows.find((r) => parseFloat(r.lineSize) === totalLineSize);
  const totalFilm = matchedRow ? matchedRow.filmEachValue : 0;

  return {
    NDEPricing: updatedRows,
    totalLineSize: parseFloat(totalLineSize.toFixed(2)),
    totalDayRate,
    totalFilm: parseFloat(totalFilm.toFixed(2)),
  };
};
